import { environment } from "environments/environment";

export const featureFlagsCRM:Record<string, boolean> = {
  enableLoyaltyPoints: !environment.production,
  enableInstallationPictures: !environment.production,
  enableCallTrend: !environment.production,
  enableCCOLeads: true,
  enableBuyoutChecks: true
}
